/**
 * Created by Simon Zhao on 7/19/21.
 * Description: the models for template MDL configuration.
 *
 * ------ maintenance history ------
 */

export interface IMDLProvider {
    fieldname: string;
    mdlsource?: string;
    mdlfieldname: string;
    providername: string;
}

export interface IFieldMDLProvider {
    mdlProvider: IMDLProvider;
}

export interface IMDLTemplate {
    mdlTemplate: Map<string, IFieldMDLProvider>;
}

export enum MDLMetaEnum {
    fieldname = 'fieldname',
    mdlsource = 'mdlsource',
    mdlfieldname = 'mdlfieldname',
    providername = 'providername',
    controlId = 'controlId',
    controlLabel = 'controlLabel'
}

export enum MDLSourceEnum {
    web = 'web'
}
